import { Card, IconButton, Tooltip, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../../OpenTabsContext";
import FieldShow from "../../unit/FieldShow";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import formatPercentage from "../../unit/formatPercentage";
import HmSubHeaderTitle from "../../unit/HmSubHeaderTitle";
import useNotify from "../../unit/useNotify";
import CustomAsideCard from "../../unit/CustomAsideCard";
import { LinkOffOutlined, OpenInBrowser } from "@mui/icons-material";
import PaidOffTenDaysList from "../../loans/PaidOffTenDaysList";
import { format } from "path";
import LoanStageStatus from "./LoanStageStatus";
const AttentionFieldShow = ({ ...props }) => {
  const title = props.title;
  const transferFailedNumber = props.transferFailedNumber;
  const insufficientBalanceCheckNumber = props.insufficientBalanceCheckNumber;
  const transferFatalErrorNumber = props.transferFatalErrorNumber;

  let textcolor = "textSecondary";

  let errorValue = [];
  if (transferFailedNumber >= 2) {
    errorValue.push("Transfer Failed");
  }
  if (insufficientBalanceCheckNumber >= 2) {
    errorValue.push("Insufficient Balance");
  }
  if (transferFatalErrorNumber >= 1) {
    errorValue.push("Funding Source Removed");
  }
  return (
    <Typography variant="body2" color={textcolor} sx={{ mb: 1 }}>
      <b>{title + ` : `} </b>
      {errorValue.map((item, index) => (
        <span key={index}>
          <br />
          {item}
        </span>
      ))}
    </Typography>
  );
};

const LoanBaseDataAside = ({ ...props }) => {
  const { openGlobalTabs } = useContext(OpenTabsContext);
  const navigate = useNavigate();
  const { successNotify, errorNotify, infoNotify } = useNotify();

  const paramAppId = props.appId;
  let appId = paramAppId;
  let record = props.record;
  let loan = record.loan;
  if (loan == undefined || loan == null) {
    return <Typography>N/A</Typography>;
  }

  const ApplicationIDLinkField = () => {
    const handleClick = (id: any, loannum: any) => {
      if (openGlobalTabs.length >= 6) {
        if (openGlobalTabs.includes("app-" + id + "-" + loannum)) {
          navigate(`/applicationSummary/` + id + "?loannum=" + loannum);
        } else {
          errorNotify("Cannot open more than 6 tabs.");
          return false;
        }
      } else {
        navigate(`/applicationSummary/` + id + "?loannum=" + loannum);
      }
    };

    return (
      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
        <b>App #: </b>
        <Link
          component="span"
          onClick={() => handleClick(paramAppId, loan.loannum)}
          className="numericText"
          underline="none"
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            "&.RaLink-link": {
              color: "#1976d2",
            },
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {paramAppId}
        </Link>
      </Typography>
    );
  };

  const CustomerIDLinkField = () => {
    const handleClick = (id: any) => {
      if (openGlobalTabs.length >= 6) {
        if (openGlobalTabs.includes("customer-" + id + "-")) {
          navigate(`/userSummary/` + id);
        } else {
          errorNotify("Cannot open more than 6 tabs.");
          return false;
        }
      } else {
        navigate(`/userSummary/` + id);
      }
    };

    return (
      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
        <b>User #: </b>
        <Link
          component="span"
          onClick={() => handleClick(record.userId)}
          className="numericText"
          underline="none"
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            "&.RaLink-link": {
              color: "#1976d2",
            },
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {record.userId}
        </Link>
      </Typography>
    );
  };

  let switchAch = record?.appPayment?.sSwitchACH;
  let repaymentAccountData = record?.appPayment?.repaymentAccountData;
  let sRepaymentPayment = record?.appPayment?.sRepaymentPayment;
  if (
    sRepaymentPayment == undefined ||
    sRepaymentPayment == null ||
    sRepaymentPayment == ""
  ) {
    sRepaymentPayment = record?.loan?.sRepaymentPayment;
  }

  return (
    <>
      <CustomAsideCard
        sx={{ p: 1, mt: 1 }}
        // id="aside-loan-summary"
        id={"aside-loan-summary-" + appId}
      >
        <HmSubHeaderTitle title={`Loan ` + loan.loanNum} />
        {/* <FieldShow
          title="Application ID"
          value={paramAppId}
          link={
            `/#/applicationSummary/` + paramAppId + `?loannum=` + loan.loanNum
          }
        /> */}
        <LoanStageStatus
          loanStatus={record?.loan?.loanStatus}
          curStatus={record?.loan?.curStatus}
          creditBalance={record?.loan?.activePrincipalBalance}
          appId={appId}
          loannum={record?.loan?.loanNum}
          modify_num={record?.loan?.modify_num}
          maturityDate={record?.loan?.maturityDate}
          transferFatalErrorNumber={record?.loan?.transferFatalErrorNumber}
          transferFailedNumber={record?.loan?.transferFailedNumber}
          insufficientBalanceCheckNumber={
            record?.loan?.insufficientBalanceCheckNumber
          }
          smartach={sRepaymentPayment == "SMART_ACH" ? true : false}
        />
        <ApplicationIDLinkField />
        <CustomerIDLinkField />
        <FieldShow title="Product" value={loan.sProductName} isBreak={false} />

        <hr />
        <FieldShow
          title="Amount to Pay Off"
          value={formatCurrency(loan.payOffAmount)}
          fontFamily="numberFontFamily"
        />
        <PaidOffTenDaysList
          data={record.paymentoff_10days}
          interestPerDiem={record?.interestPerDiem}
        />
        <FieldShow
          title="Current Daily Interest"
          value={formatCurrency(record?.interestPerDiem) || "$0.00"}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Interest Since Last Payment"
          value={formatCurrency(record?.accruedInterestAmount) || "$0.00"}
          fontFamily="numberFontFamily"
        />
        <hr />
        <FieldShow
          title="Note Amount"
          value={
            loan.originalNoteAmount
              ? formatCurrency(loan.originalNoteAmount)
              : ""
          }
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Original Principal"
          value={loan.loanAmount ? formatCurrency(loan.loanAmount) : ""}
          fontFamily="numberFontFamily"
        />

        <FieldShow
          title="Interest Rate"
          value={formatPercentage(loan.interestRate / 100)}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Interest Accrual Method"
          value={
            loan.interestAccrualMethod === "Per period"
              ? "Per period"
              : "Daily accrual"
          }
        />
        <FieldShow
          title="Note Date"
          value={formatDate(loan.originalNoteDate)}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Expected Maturity"
          value={formatDate(loan.maturityDate)}
          fontFamily="numberFontFamily"
        />

        <FieldShow title="Payment Frequency" value={loan.paymentFrequency} />
        <hr />
        {/* <FieldShow
          title="Total Scheduled Payments"
          value={loan.noteTerm}
          fontFamily="numberFontFamily"
        /> */}
        <FieldShow
          title="Number of Payments Received"
          value={loan.paymentsReceived}
        />
        <FieldShow
          title="Number of Payments Missed"
          value={loan.paymentsMissed}
        />
        <FieldShow
          title="Number of Payments Remaining"
          value={loan.remainingPayments}
        />
        <hr />
        <FieldShow
          title="Last Payment Date"
          value={formatDate(loan.lastPaymentDate)}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Next Payment Date"
          value={formatDate(loan.nextPaymentDate)}
          fontFamily="numberFontFamily"
        />
        <hr />
        <FieldShow
          title="Payment Source"
          value={
            loan.paymentsource &&
            loan.paymentsource +
              " (" +
              (loan.paymentaccount
                ? loan.paymentaccount.replace(/.(?=.{4})/g, "")
                : "") +
              ")"
          }
        />
        {/* show paymentaccount, Last 4 Digit Account Number */}
        {/* <FieldShow
          title="Account Number"
          value={
            loan.paymentaccount
              ? loan.paymentaccount.replace(/.(?=.{4})/g, "*")
              : ""
          }
          fontFamily="numberFontFamily"
        /> */}

        {/* <FieldShow
          title="Number of Modifications"
          value={loan.modify_num}
          fontFamily="numberFontFamily"
        />
        <AttentionFieldShow
          title="Attention Required"
          transferFailedNumber={loan.transferFailedNumber}
          insufficientBalanceCheckNumber={loan.insufficientBalanceCheckNumber}
          transferFatalErrorNumber={loan.transferFatalErrorNumber}
        /> */}
      </CustomAsideCard>
    </>
  );
};

export default LoanBaseDataAside;
